import { render, staticRenderFns } from "./CreateUpdateBuilding.vue?vue&type=template&id=bcd12cdc&"
import script from "./CreateUpdateBuilding.vue?vue&type=script&lang=ts&"
export * from "./CreateUpdateBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports